export function getNestedProperty(obj: unknown, pathStr: string): unknown {
  if (!obj || typeof obj !== 'object') return undefined;
  const parts = pathStr.split('.');
  let curr: any = obj;
  for (const part of parts) {
    if (curr == null || typeof curr !== 'object') return undefined;
    curr = curr[part];
  }
  return curr;
}

export function setNestedProperty(obj: Record<string, any>, pathStr: string, value: unknown): void {
  const parts = pathStr.split('.');
  let curr = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    const part = parts[i];
    if (curr[part] == null || typeof curr[part] !== 'object' || Array.isArray(curr[part])) {
      curr[part] = {};
    }
    curr = curr[part];
  }
  curr[parts[parts.length - 1]] = value;
}

export function resolveCopyValue(data: unknown, pathStr: string): string | undefined {
  if (!data || typeof data !== 'object') return undefined;
  const asObj = data as Record<string, any>;
  if (asObj.text && typeof asObj.text === 'object' && !pathStr.startsWith('text.')) {
    const val = getNestedProperty(asObj.text, pathStr);
    if (val !== undefined && val !== null) return String(val);
  }
  const direct = getNestedProperty(asObj, pathStr.startsWith('text.') ? pathStr.replace(/^text\./, '') : pathStr);
  if (direct !== undefined && direct !== null) return String(direct);
  return undefined;
}
